import { api } from '../client';
import type { Permission } from '../types';

/**
 * /api/permissions do Traccar é um endpoint "link/unlink" entre objetos.
 * Não tem GET; pra saber quais embarcações um usuário tem, faça GET /devices?userId=X
 * (ou GET /geofences?userId=X, etc).
 *
 * Permission body precisa ter exatamente 2 chaves:
 * - userId + (deviceId | groupId | geofenceId | calendarId | managedUserId | attributeId | driverId)
 * - deviceId + (geofenceId | groupId | calendarId | attributeId | driverId)
 * - groupId + (geofenceId | calendarId | attributeId | driverId)
 */
export const permissionsApi = {
  link: (link: Permission) => api.post<Permission>('/permissions', { body: link }),
  unlink: (link: Permission) => api.delete<void>('/permissions', { body: link }),
};
